import styled from 'styled-components';

/**
 * This is also defined in tailwind.config.js
 */
export const colors = {
  primary: '#0038b8',
  secondary: '#E0EAFF',
  normal: '#2C2D2E',
  subtle: '#767676',
  grey: '#6A6B6B',
  faintGrey: '#E2E7EA',
  lightGrey: '#D8D8D8',
  background: '#F6F7F9',
  error: '#DF1667',
  highlight: 'rgba(85, 162, 233, 0.37)',
  lightBlue: '#1274BD',
};

export const H1 = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ color = colors.normal }) => color};
`;

export const H2 = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.035em;
  color: ${({ color = colors.normal }) => color};
`;

export const H3 = styled.div<{ weight?: 'normal' | 'bold' | '600' }>`
  font-style: normal;
  font-weight: ${({ weight = 'bold' }) => weight};
  font-size: 18px;
  color: ${({ color = colors.normal }) => color};
`;

export const H4 = styled.div<{ up?: boolean }>`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: ${({ color = colors.grey }) => color};
  text-transform: ${({ up = false }) => up && 'uppercase'};
`;

export const H5 = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ color = colors.grey }) => color};
`;

export const Regular = styled.div<{ weight?: 'normal' | 'bold' | '600'; wrap?: 1 | 0 }>`
  font-style: normal;
  font-weight: ${({ weight = 'normal' }) => weight};
  font-size: 14px;
  letter-spacing: 0.035em;
  color: ${({ color = colors.normal }) => color};
  white-space: ${({ wrap = true }) => (wrap ? 'normal' : 'nowrap')};
`;

export const Description = styled.div<{ weight?: '400' | '600' | '700' }>`
  font-style: normal;
  font-weight: ${({ weight = '600' }) => weight};
  font-size: 16px;
  color: ${({ color = colors.normal }) => color};
`;
